import React, { useState } from "react";
import Chart from "react-apexcharts";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";
import { PieBarChart } from "./PieBarChart";

const timeOptions = [
    { value: 15, label: "15 Seconds" },
    { value: 30, label: "30 Seconds" },
    { value: 60, label: "1 Minute" },
    { value: 300, label: "5 Minutes" },
    { value: 600, label: "10 Minutes" },
    { value: 900, label: "15 Minutes" },
    { value: 1800, label: "30 Minutes" },
    { value: 3600, label: "1 Hour" },
];

const AgentWiseAvgCallLength: React.FC<dashboardChartProps> = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedCallType, onChartLoaded }) => {

    const [selectedDuration, setSelectedDuration] = useState("");
    const chartData = PieBarChart({
        apiEndpoint, startDate, endDate, labelKey: "agent_name", valueKey: "averageInSeconds",
        payloadExtra: { call_type: selectedCallType, location_id: selectedLocation, duration: selectedDuration }, onChartLoaded,
        chartName:"AgentAvgCallLength"
    });

    return (
        <div className="overflow-hidden">
            <div className="row mb-3 chart-header" style={{ borderBottom: "2px solid #ddd", paddingBottom: "10px", background: "gray" }}>
                <div className="col-12">
                    <h5 className="text-center">Agent Average Call Length</h5>
                </div>
            </div>

            <div className="p-3 d-flex align-items-center gap-5">
                <div><label style={{ minWidth: "80px", margin: 0 }}>Duration</label></div>
                <select
                    className="form-select pe-5"
                    value={selectedDuration}
                    style={{ width: "300px" }}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                >
                    <option value="">Select</option>
                    {timeOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

            <div className="col-12">
                {chartData && chartData.count > 0 ? (
                    <Chart options={chartData.labels} series={chartData.series} type="bar" height={380} />
                ) : (
                    <div className="text-center py-4">No Records Found</div>
                )}
            </div>
        </div>
    );
};

export default AgentWiseAvgCallLength;
